export default __webpack_public_path__ + "static/media/ActiveEnergyAssetTypeIcon.29916563.svg";